/**
 * 支援語言清單（單一登記處）——加語言 = ① 加 locales/<code>.ts 字典檔 ② 這裡加一行。零架構改動。
 */
import zhHK from './locales/zh-HK';
import zhCN from './locales/zh-CN';
import en from './locales/en';
import ms from './locales/ms';
import ar from './locales/ar';
import es from './locales/es';
import type { Dict } from './dicts';

export interface LocaleMeta {
  code: string;
  /** 自身語言名（切換器顯示用——永遠用本語言寫） */
  nativeName: string;
  dir: 'ltr' | 'rtl';
  /** <html lang> 值（zh-HK 用 zh-Hant-HK 以明確標示繁體） */
  htmlLang: string;
  dict: Dict;
}

export const LOCALES: LocaleMeta[] = [
  { code: 'zh-HK', nativeName: '繁體中文', dir: 'ltr', htmlLang: 'zh-Hant-HK', dict: zhHK },
  { code: 'zh-CN', nativeName: '简体中文', dir: 'ltr', htmlLang: 'zh-CN', dict: zhCN },
  { code: 'en', nativeName: 'English', dir: 'ltr', htmlLang: 'en', dict: en },
  { code: 'ms', nativeName: 'Bahasa Melayu', dir: 'ltr', htmlLang: 'ms', dict: ms },
  { code: 'ar', nativeName: 'العربية', dir: 'rtl', htmlLang: 'ar', dict: ar },
  { code: 'es', nativeName: 'Español', dir: 'ltr', htmlLang: 'es', dict: es },
];

export const DEFAULT_LOCALE = 'zh-HK';
export const LOCALE_STORAGE_KEY = 'jkdcoding_locale';
/** 舊 languageStore 的 storage key（值 'zh'|'en'）——一次性遷移後移除 */
export const LEGACY_STORAGE_KEY = 'jkd-language';
export const LEGACY_LANG_MAP: Record<string, string> = { zh: 'zh-HK', en: 'en' };
